import { render } from "./offeringDetailsView.vue?vue&type=template&id=fb191974&scoped=true"
import script from "./offeringDetailsView.vue?vue&type=script&lang=js"
export * from "./offeringDetailsView.vue?vue&type=script&lang=js"

import "./offeringDetailsView.vue?vue&type=style&index=0&id=fb191974&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb191974"]])

export default __exports__